import { render } from "./PaginationLinks.vue?vue&type=template&id=59d35cdf"
import script from "./PaginationLinks.vue?vue&type=script&lang=js"
export * from "./PaginationLinks.vue?vue&type=script&lang=js"

import exportComponent from "/home/nginx/domains/tools.androidrepublic.org/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"PaginationLinks.vue"]])

export default __exports__